import { usePunditUserContext } from "@circle-react/contexts/punditUserContext";
import { homeTabsCustomNameQueries } from "@circle-react/lib/queries/homeTabsCustomNames";
import { useQuery } from "react-query";

import { t } from "@/i18n-js/instance";

/**
 * Label for the mobile "Spaces" tab/page - respects a rename set via the
 * Branded Apps Builder's Home Tabs section (e.g. "Spaces" -> "Menu"), falling
 * back to the default translation. Shared by DefaultSectionTabs (tab label)
 * and SpacesContent (document title) so they can never drift out of sync.
 */
export const useSpacesTabLabel = () => {
  const { currentCommunityMember, currentCommunity } = usePunditUserContext();

  const { data: homeTabsCustomNames } = useQuery(
    homeTabsCustomNameQueries.forMember({
      communityId: currentCommunity?.id,
      communityMemberId: currentCommunityMember?.id,
    }),
  );

  return homeTabsCustomNames?.spaces || t("spaces_label");
};
